import React from "react";

/** Keeps one broken pane from blanking the whole studio: shows what failed and offers a reload, and keeps the last crash for diagnosis. */
export class ErrorBoundary extends React.Component<{ name: string; children: React.ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[${this.props.name}] crashed`, error, info.componentStack);
    try { fetch("/api/crash", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ where: this.props.name, message: String(error?.message ?? error), stack: String(error?.stack ?? "").slice(0, 4000), componentStack: String(info?.componentStack ?? "").slice(0, 4000), url: location.href, at: new Date().toISOString() }) }).catch(() => {});
      localStorage.setItem("studio.lastCrash", JSON.stringify({ at: new Date().toISOString(), where: this.props.name, message: error.message, stack: error.stack, components: info.componentStack, url: location.href })); } catch { /* ignore */ }
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="col" style={{ padding: 24, gap: 12, maxWidth: 720 }}>
        <span className="eyebrow">Something went wrong in the {this.props.name}</span>
        <div style={{ fontSize: 15, fontWeight: 700 }}>{error.message}</div>
        <pre style={{ fontSize: 11, color: "var(--muted)", whiteSpace: "pre-wrap", maxHeight: 220, overflow: "auto", background: "var(--panel2)", padding: 12, borderRadius: 10 }}>{error.stack}</pre>
        <div className="row" style={{ gap: 8 }}>
          <button className="btn sm primary" onClick={() => this.setState({ error: null })}>Try again</button>
          <button className="btn sm" onClick={() => location.reload()}>Reload the page</button>
        </div>
        <span className="hint">The details are saved on this browser (studio.lastCrash) so they can be looked at later.</span>
      </div>
    );
  }
}
